import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

interface StyleProps {
  modalCss?: {
    height?: string;
    maxWidth?: string;
    overflow?: string;
    padding?: string;
  }
}

const useStyles = makeStyles((theme: Theme) => ({
  dialog: ({ modalCss }: StyleProps) => ({
    '& .MuiDialog-container .MuiPaper-root': {
      padding: 26,
      position: 'relative',
      maxWidth: 448,
      borderRadius: 16,
      background: theme.palette.spBackground,
      '& .MuiSvgIcon-root': {
        position: 'absolute',
        right: 26,
        top: 26,
        color: theme.palette.grey[400],
        '&:hover': {
          cursor: 'pointer'
        }
      },
      ...modalCss
    },
  }),

  dialogSimple: {
    padding: '0 !important',

    '& .MuiDialogContent-root': {
      padding: '0 !important'
    }
  },

  topDots: {
    position: 'absolute',
    top: '-270px',
    left: '-260px',
    zIndex: 1,
  },

  bottomDots: {
    position: 'absolute',
    top: '24%',
    left: '30%',
    zIndex: 1,
  },

  dialogContent: {
    zIndex: 2
  },
  dialogTitle: {
    '& h1': {
      fontWeight: 700,
      fontSize: 24,
      lineHeight: '24px',
      fontStyle: 700,
      color: theme.palette.common.black,
      marginBottom: 16
    },
    '& h2': {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '24px',
      textAlign: 'center',
      fontStyle: '24px',
      color: theme.palette.grey[700]
    }
  }
}))

export default useStyles
